import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { hero_constants } from "./constants";

const Hero = () => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(
      () => {
        const current = hero_constants.texts[currentIndex];

        if (isDeleting) {
          setCurrentText(current.substring(0, currentText.length - 1));
        } else {
          setCurrentText(current.substring(0, currentText.length + 1));
        }

        if (!isDeleting && currentText === current) {
          setTimeout(() => setIsDeleting(true), 2000); // Pause before deleting
        } else if (isDeleting && currentText === "") {
          setIsDeleting(false);
          setCurrentIndex(
            (prevIndex) => (prevIndex + 1) % hero_constants.texts.length
          );
        }
      },
      isDeleting ? 50 : 100
    ); // Faster deletion, slower typing

    return () => clearTimeout(timeout);
  }, [currentText, currentIndex, isDeleting]);

  return (
    <section className="relative min-h-screen bg-landing-hero bg-cover bg-center bg-no-repeat">
      <div className="relative container flex justify-center items-center min-h-[90dvh] px-3 py-10">
        <div className="flex flex-col lg:flex-row items-center gap-[60px] md:gap-5">
          <div className="flex-1  space-y-[24px]">
            <h1 className="text-[28px] lg:text-[54px] font-bold text-[#0E2B5D]">
              {hero_constants.title}
              <br />
              <span className="text-[#0165FE] block lg:inline">
                {currentText}
                <span className="animate-pulse">|</span>
              </span>
            </h1>

            <p className="text-[#222] lg:text-lg">
              {hero_constants.description}
            </p>

            <div className="flex  gap-[24px]">
              <Link
                to="/signup"
                className="bg-primary_alt px-4 h-max py-2.5 rounded-lg border border-[#B6E4FF] text-white font-medium w-[200px] md:w-auto text-center"
              >
                Get Started
              </Link>

              <Link
                className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max hidden md:block text-primary_alt font-medium"
                to="/signup"
              >
                Request Custom Development
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="flex-1 relative">
            <img
              src={hero_constants.image}
              alt="AI Solutions Team"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
